module.exports = __webpack_public_path__ + "img/arrow-left.601b1ce2.svg";